import '../../../../../../../public/m/js/ec/details.setup.js';

import Vue from 'vue';
import Vuex from 'vuex';
import { default as VueModal } from 'vue-js-modal';
import VueLazyLoad from 'vue-lazyload';
import axios from '../../../api/common/axios';

import { initialize } from '../../../util/sentry';

initialize(Vue);

import lozad from '../../../components/shop/details/expremanental/lozad';

window.lozadObserver = lozad('.js-lazy');

import productComponent from '../../../components/shop/details/mobiledetails';
import mobileSliderComponent from '../../../components/shop/details/mobileSlider.vue';
import followLabelButtonComponent from '../../../components/followingLabels/followLabelButton.vue';
import otapediaArticlesComponent from '../../../components/shop/details/otapediaArticles';
import shippingFromJapanComponent from '../../../components/shop/details/expremanental/shippingFromJapan.vue';
import shippingInfoQAComponent from '../../../components/shop/details/expremanental/shippingInfoQA.vue';
import addToCartFromPremiumComponent from '../../../components/shop/details/expremanental/addToCartFromPremium.vue';
import productListComponent from '../../../components/shop/products/productsList.vue';
import userCommentsComponent from '../../../components/userComments/userComments.vue';

import guestMailMagazine from '../../../components/common/guestMailMagazine.vue';

import AudioContents from '../../../stores/schema/AudioContents';

import userStore from '../../../stores/modules/user';
import labelsStore from '../../../stores/modules/labels';
import productStore from '../../../stores/modules/product';
import productSkusStore from '../../../stores/modules/productskus';
import shoppingCartStore from '../../../stores/modules/shoppingcart';
import searchProductsStore from '../../../stores/modules/searchproducts';
import premiumPlanStore from '../../../stores/modules/premiumPlan';
import shippingsStore from '../../../stores/modules/shippings';
import paymentsStore from '../../../stores/modules/payments';
import shipmentsStore from '../../../stores/modules/shipments';
import premiumPlansStore from '../../../stores/modules/premiumPlans';
import audioPlayerStore from '../../../stores/modules/audioPlayer';

const store = new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  state: {
    authType: null,
    addToCartFromPremumSummaryTrigger: 0,
    lazyloadTrigger: 0
  },
  mutations: {
    authType(state, type) {
      state.authType = type;
    },
    incrementAddToCartFromPremumSummaryTrigger(state) {
      state.addToCartFromPremumSummaryTrigger++;
    },
    incrementLazyloadTrigger(state) {
      state.lazyloadTrigger++;
    }
  },
  actions: {
    addToCartFromPremumSummaryTrigger({ commit }) {
      commit('incrementAddToCartFromPremumSummaryTrigger');
    }
  },

  modules: {
    user: {
      namespaced: true,
      state: userStore.state,
      actions: userStore.actions,
      mutations: userStore.mutations
    },

    labels: labelsStore,

    product: {
      namespaced: true,
      state: productStore.state,
      getters: productStore.getters,
      actions: productStore.actions,
      mutations: productStore.mutations,

      modules: {
        skus: {
          namespaced: true,
          state: productSkusStore.state,
          getters: productSkusStore.getters,
          actions: productSkusStore.actions,
          mutations: productSkusStore.mutations
        }
      }
    },

    cart: shoppingCartStore,

    searchProducts: searchProductsStore,

    premium: {
      namespaced: true,
      state: premiumPlanStore.state,
      actions: premiumPlanStore.actions,
      mutations: premiumPlanStore.mutations
    },

    shipping: {
      namespaced: true,
      state: shippingsStore.state,
      getters: shippingsStore.getters,
      actions: shippingsStore.actions,
      mutations: shippingsStore.mutations
    },

    payment: {
      namespaced: true,
      state: paymentsStore.state,
      getters: paymentsStore.getters,
      actions: paymentsStore.actions,
      mutations: paymentsStore.mutations
    },

    shipments: shipmentsStore,

    premiumPlans: premiumPlansStore,

    audioContents: {
      namespaced: true,
      state: {
        ...AudioContents.state
      },
      getters: {
        ...AudioContents.getters
      },
      actions: {
        // IDを指定してコンテンツを取得して上書き
        async fetchById({ commit }, payload) {
          const id = payload._id;
          const res = await axios.get(`/shop/audio_contents/${id}`, {});
          if (!res || !res.data) {
            return;
          }
          commit('responseData', res.data);
        }
      },
      // 表示するコンテンツIDを指定（router.beforeEachから）
      async selectContent({ commit }, payload) {
        commit('selectContentId', payload._id);
      },
      mutations: {
        // AudioContents データをリストに格納
        responseData(state, metadata) {
          if (
            metadata.audio_content_progress &&
            metadata.audio_content_progress.chapter_index
          ) {
            metadata.audio_content_progress.chapter_index = Number(
              metadata.audio_content_progress.chapter_index
            );
          }
          AudioContents.updateById(metadata._id, metadata, { upsert: true });
        },
        // 表示するコンテンツのIDを登録
        selectContentId(state, id) {
          state.selectedId = id;
        }
      }
    },

    audioPlayer: {
      namespaced: true,
      state: audioPlayerStore.state,
      getters: audioPlayerStore.getters,
      actions: audioPlayerStore.actions,
      mutations: audioPlayerStore.mutations
    }
  }
});

Vue.use(VueModal, { componentName: 'vue-modal' });
Vue.use(VueLazyLoad, { observer: true });

new Vue({
  el: '#vue-product',
  store,
  components: {
    'vue-product': productComponent,
    'vue-follow-label-button': followLabelButtonComponent,
    'vue-otapedia-articles': otapediaArticlesComponent,
    'vue-shipping-from-japan': shippingFromJapanComponent,
    'vue-shipping-info-qa': shippingInfoQAComponent,
    'vue-add-to-cart-from-premium': addToCartFromPremiumComponent,
    'vue-product-list': productListComponent,
    'vue-user-comments': userCommentsComponent,
    'vue-guest-mail': guestMailMagazine,
    'vue-mobile-slider': mobileSliderComponent
  },
  computed: {
    selectedSku() {
      return this.$store.getters['product/skus/selectedSku'];
    }
  }
});

import '../../common/searchbox';
import './suggestedproducts';

import '../../../../../../../public/m/js/ec/details.finish.js';

if (window.nWaitingProviders) {
  window.addEventListener('AllResolverDone', () => {
    store.commit('incrementLazyloadTrigger');
  });
} else {
  store.commit('incrementLazyloadTrigger');
}
